<template>
    <b-container fluid>
        <b-row align-v="center">
            <b-col cols="12" lg="6" v-if="['vigilante'].includes(this.currentProfile.slug)">
                <app-form-select
                    v-model="filters.personId"
                    resource="people"
                    label="Residente"
                    :hard-filters="{ venueId: this.currentVenue.id }"
                    @keyup.enter="filter"
                ></app-form-select>
            </b-col>
            <b-col cols="12" lg="6" v-if="['vigilante'].includes(this.currentProfile.slug)">
                <app-form-select
                    v-model="filters.structureId"
                    resource="structures"
                    label="Unidad"
                    :hard-filters="{ venueId: this.currentVenue.id }"
                    @keyup.enter="filter"
                ></app-form-select>
            </b-col>
            <b-col cols="12" lg="6">
                <app-form-input @keyup.enter="onFilter" label="Nombre" v-model="filters.searchName"></app-form-input>
            </b-col>
            <b-col cols="12" lg="6">
                <app-form-select v-model="filters.visitorTypeId" resource="visitor-types" label="Tipo de Visitante" @keyup.enter="filter"></app-form-select>
            </b-col>
            <b-col cols="12" lg="6">
                <label for="datepicker">Fecha Inicio</label>
                <b-form-datepicker id="datepicker" v-model="filters.from" class="mb-2"></b-form-datepicker>
            </b-col>
            <b-col cols="12" lg="6">
                <label for="datepicker">Fecha Fin</label>
                <b-form-datepicker id="datepicker" v-model="filters.to" class="mb-2"></b-form-datepicker>
            </b-col>
            <b-col cols="12" lg="6">
                <app-form-select
                    v-model="filters.status"
                    :options="statusOptions"
                    textField="text"
                    valueField="value"
                    label="Estado"
                    @keyup.enter="filter"
                ></app-form-select>
            </b-col>
            <b-col class="right-spaced mt-4">
                <b-btn variant="primary" class="btn-block-xs-only" size="sm" @click="onFilter"><i class="fas fa-filter"></i></b-btn>
                <b-btn variant="secondary" class="btn-block-xs-only" size="sm" @click="onClear"><i class="fas fa-times"></i></b-btn>
                <app-btn-excel class="btn-block-xs-only" size="sm" @click="onDownloadReport"></app-btn-excel>
            </b-col>
        </b-row>
    </b-container>
</template>
<script>
export default {
    data: () => ({
        filters: {
            searchName: '',
            visitorTypeId: '',
            personId: '',
            structureId: '',
            status: '',
            from: '',
            to: '',
        },
        statusOptions,
    }),
    methods: {
        onFilter() {
            this.$emit('filter', this.filters)
        },
        onClear() {
            Object.keys(this.filters).map((key) => (this.filters[key] = ''))
            this.$emit('filter', null)
        },
        onDownloadReport() {
            const query = Object.keys(this.filters)
                .map((key) => `${_.snakeCase(key)}=${this.filters[key] || ''}`)
                .join('&')
            window.open(`web/v1/downloads/${this.currentVenue.id}/download-access-authorizations?${query}`)
        },
    },
}
const statusOptions = [
    {
        value: 'approved',
        text: 'Aprobado',
    },
    {
        value: 'rejected',
        text: 'No aprobado',
    },
    {
        value: 'pending',
        text: 'Pendiente',
    },
]
</script>
